/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: { borderColor: '#b2b9bf', outerBorderColor: '#b2b9bf' }
    },
    {
      if: { hover: true },
      tokens: { borderColor: '#e3e6e8', borderWidth: 3 }
    },
    {
      if: { pressed: true },
      tokens: { borderColor: '#676e73', borderWidth: 3 }
    },
    {
      if: { selected: true },
      tokens: { borderColor: '#4b286d', borderWidth: 2, titleColor: '#4b286d' }
    }
  ],
  tokens: {
    borderColor: '#e3e6e8',
    borderRadius: 4,
    borderWidth: 2,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderRadius: 8,
    outerBorderWidth: 2,
    pressableBorderTopColor: '#e3e6e8',
    pressableBorderTopWidth: 1,
    pressablePaddingBottom: 16,
    pressablePaddingHorizontal: 24,
    pressablePaddingVertical: 16,
    splashButtonRadius: 4,
    subTitleColor: '#676e73',
    titleColor: '#414547'
  }
}
export default theme
